var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgV6(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 138,
    height: 138,
    viewBox: "0 0 138 138",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-park-outline:baby-feet"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M43.125 59.2595C39.031 76.9407 61.7924 81.4401 56.419 93.8975C51.0428 106.352 39.0109 103.862 40.3535 116.317C41.699 128.774 57.6208 128.949 72.1165 121.446C101.105 106.435 107.154 73.6488 94.0355 59.2595C77.9125 41.5782 47.219 41.5782 43.125 59.2595Z",
    stroke: "white",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M93.7442 45.5204C96.1768 47.5617 100.631 46.2583 103.693 42.6093C106.755 38.9603 107.265 34.3474 104.832 32.3061C102.4 30.2649 97.9453 31.5682 94.8834 35.2172C91.8216 38.8663 91.3115 43.4791 93.7442 45.5204Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M80.8249 38.3019C83.703 39.644 87.6681 37.2322 89.6813 32.9151C91.6944 28.5979 90.9932 24.0102 88.1151 22.6681C85.237 21.326 81.2719 23.7378 79.2587 28.0549C77.2456 32.3721 77.9468 36.9598 80.8249 38.3019Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M66.3187 36.1867C69.4769 36.5187 72.4408 32.9474 72.9388 28.21C73.4367 23.4726 71.2801 19.3632 68.1218 19.0312C64.9636 18.6993 61.9997 22.2706 61.5018 27.0079C61.0038 31.7453 63.1605 35.8548 66.3187 36.1867Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M44.1832 33.8066C48.6594 32.1774 50.5271 26.0184 48.3548 20.0502C46.1826 14.0819 40.7929 10.5644 36.3168 12.1936C31.8406 13.8228 29.9729 19.9818 32.1451 25.95C34.3174 31.9183 39.707 35.4358 44.1832 33.8066Z",
    stroke: "white",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M104.181 55.9601C106.222 58.3928 110.835 57.8827 114.484 54.8208C118.133 51.7589 119.437 47.3047 117.395 44.872C115.354 42.4394 110.741 42.9494 107.092 46.0113C103.443 49.0732 102.14 53.5274 104.181 55.9601Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgV6);
export default __webpack_public_path__ + "static/media/v6.d32501171b20f1b788c38d8f34bc6f20.svg";
export { ForwardRef as ReactComponent };